<div class="reviews">
<div class = "container">
  <div class = "row">
      <div class = "col-md-12">

          <div class = "carousel slide" data-bs-ride = "carousel" id = "quote-carousel">
            <ol class = "carousel-indicators wow animate__fadeInUp">
              <li data-bs-target = "#quote-carousel" data-bs-slide-to = "0" class = "active"> <img src="../../theme/images/client-image1.webp" class = "client-img" alt="client" width="50" height="50" loading="lazy"> 
              </li>
              <li data-bs-target = "#quote-carousel" data-bs-slide-to= "1"> <img src="../../theme/images/client-image2.webp" class = "client-img" alt="client" width="50" height="50" loading="lazy">
              </li>
              <li data-bs-target = "#quote-carousel" data-bs-slide-to = "2"><img src="../../theme/images/client-image3.webp" class = "client-img" alt="client" width="50" height="50" loading="lazy">
              </li>
              <li data-bs-target = "#quote-carousel" data-bs-slide-to = "3"><img src="../../theme/images/client-image4.webp" class = "client-img" alt="client" width="50" height="50" loading="lazy">
              </li>
          </ol>
              <!-- Carousel Slides / Quotes -->
              <div class = "carousel-inner text-center wow animate__fadeInUp" data-wow-delay="300ms">

                  <!-- Quote 1 -->
                  <div class = "carousel-item active">
                      <blockquote>
                        <div class="star">
                          <i class="fas fa-star checked"></i>
                          <i class="fas fa-star checked"></i>
                          <i class="fas fa-star checked"></i>
                          <i class="fas fa-star checked"></i>
                          <i class="fas fa-star checked"></i>
                          <p class="review-title">Great Service</p>
                        </div>
                          <div class = "row">
                              <div class = "col-12">
                                <p class="review-content">
                                  The service was great, and delivery very fast. Got a very clean list back and started emailing to it
                                  right away, with very good results. I will definitely be a regular client.
                                </p>
                                <p class="author">Roscoe S.</p>
                              </div>
                          </div>
                      </blockquote>
                  </div>
                  <!-- Quote 2 -->
                  <div class = "carousel-item">
                    <blockquote>
                      <div class="star">
                        <i class="fas fa-star checked"></i>
                        <i class="fas fa-star checked"></i>
                        <i class="fas fa-star checked"></i>
                        <i class="fas fa-star checked"></i>
                        <i class="fas fa-star checked"></i>
                        <p class="review-title">What a great service</p>
                      </div>
                        <div class = "row">
                            <div class = "col-12">
                              <p class="review-content">
                                The ease of use was fantastic. 2 clicks is all we needed to do and our files get scrubbed and sent
                                back to us.
                              </p>
                              <p class="author">Larry G.</p>
                            </div>
                        </div>
                    </blockquote>
                </div>
                  <!-- Quote 3 -->
                  <div class = "carousel-item">
                    <blockquote>
                      <div class="star">
                        <i class="fas fa-star checked"></i>
                        <i class="fas fa-star checked"></i>
                        <i class="fas fa-star checked"></i>
                        <i class="fas fa-star checked"></i>
                        <i class="fas fa-star checked"></i>
                        <p class="review-title"> Use and results of KudosHub Email Validation Software</p>
                      </div>
                        <div class = "row">
                            <div class = "col-12">
                              <p class="review-content">
                                The software offers a simple, usable interface. The quality of the list cleaning is as good as or
                better than most other "List Cleaning" software we have used.
                              </p>
                              <p class="author">Stan G.</p>
                            </div>
                        </div>
                    </blockquote>
                </div>
                <div class = "carousel-item">
                  <blockquote>
                    <div class="star">
                      <i class="fas fa-star checked"></i>
                      <i class="fas fa-star checked"></i>
                      <i class="fas fa-star checked"></i>
                      <i class="fas fa-star checked"></i>
                      <i class="fas fa-star checked"></i>
                      <p class="review-title">  Great Tool!</p>
                    </div>
                      <div class = "row">
                          <div class = "col-12">
                            <p class="review-content">
                              Great experience, job well done, everything was made simple and fast. It works as it should.No
                hassle or complications with the software. Easy to start right away. Very user friendly.
                            </p>
                            <p class="author">Nick G.</p>
                          </div>
                      </div>
                  </blockquote>
              </div>
                </div>
              <!-- Carousel Buttons Next/Prev -->
              <a data-bs-slide = "prev" href = "#quote-carousel" class = "left carousel-control" aria-label="Previous testimonial"><i class = "fas fa-chevron-left"> </i> </a>
              <a data-bs-slide = "next" href = "#quote-carousel" class = "right carousel-control" aria-label="Next testimonial"><i class = "fas fa-chevron-right"></i></a>
          </div>
      </div>
  </div>
</div>
</div>